import { isBrowser } from '@whelk/utils/src/next';

export const CHAT_PAGE_TYPE = 'type';

export const CHAT_ID = 'chatID';

export const HOME_URL = '/';
export const HISTORY_URL = '/history';
export const DOWNLOAD_URL = '/download';
export const SHARE_CHAT_BASE_URL = '/share/chat';

export const CHAT_BASE_URL = '/?type=chat&chatID';

export const EXAMPLE_BASE_URL = '/?type=example&exampleID=';

export const MINIMAX_URL_CN = 'https://minimaxi.com';
export const MINIMAX_URL_OVERSEA = 'https://www.minimax.io';

export const PAGE_TYPE = {
  HOME: 'home',
  EXAMPLE: 'example',
  CHAT: 'chat',
  HISTORY: 'history',
} as const;

export type TextPageEnum = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];

// 需要token的页面: example、history
export const checkIsNeedTokenPath = () => {
  if (!isBrowser) return false;
  const path = window.location.href;
  const tokenRequiredUrls = [CHAT_BASE_URL, HISTORY_URL];
  return tokenRequiredUrls.some((url) => path.includes(url));
};

// 不需要顶部导航栏
export const NO_NEED_HEADER_PATHS = [
  HOME_URL,
  HISTORY_URL,
  DOWNLOAD_URL,
  SHARE_CHAT_BASE_URL,
  // SHARE_BOT_BASE_URL,
];

export const checkNeedHeaderPath = (pathname: string) => {
  let needHeader = true;

  NO_NEED_HEADER_PATHS.forEach((item) => {
    if (item === HOME_URL) {
      // 首页单独判断，因为首页是'/'，会误伤其他路径
      if (pathname === item) {
        needHeader = false;
      }
    } else if (pathname?.startsWith(item)) {
      needHeader = false;
    }
  });
  return needHeader;
};

export function buildUrl(path: string, params: Record<string, string>) {
  const searchParams = new URLSearchParams(params);
  return `${path}?${searchParams.toString()}`;
}
